import axios from './index';

class UserApi {
  static List = (data) => {
    let query = '?';
    if (data.userType) {
      query += `user_type=${data.userType}&`;
    }
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.companyId) {
      query += `company_id=${data.companyId}&`;
    }
    if (data.operationLocationId) {
      query += `operation_location_id=${data.operationLocationId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${userBase}/${query}`);
  };

  static UserDelete = (data) => {
    const config = {
      headers: { accessToken: data.token },
      data: { id: data.id },
    };
    return axios.delete(`${userBase}/deletebyId`, config);
  };
  static Create = (data) => {
    let request = {
      name: data.name,
      email: data.email,
      phone_number: String(data.phoneNumber),
      user_type: data.userType,
      status: data.status,
    };
    return axios.post(`${userBase}/`, request);
  };

  static Update = (data) => {
    let request = {};
    if (data.name) request.name = data.name;
    if (data.email) request.email = data.email;
    if (data.phoneNumber) request.phone_number = data.phoneNumber;
    if (data.userType) request.user_type = data.userType;
    if (data.status) request.status = data.status;

    return axios.put(`${userBase}/${data.userId}`, request);
  };

  static GetById = (id) => {
    return axios.get(`auth/admin/customer/${id}`);
  };

  static ListPermissionGroupsAssigned = (data) => {
    let query = '?';
    if (data.adminUserId) {
      query += `user_id=${data.adminUserId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${userPermissionBase}${query}`);
  };

  static AddPermissionGroupToUser = (data) => {
    // console.log('payload from Admin User = ', data);
    let request = {
      user_id: data.adminUserId,
      group_id: data.permissionGroupId,
    };
    return axios.post(`${userPermissionBase}`, request);
  };

  static StatusPermissionGroupToUser = (data) => {
    console.log('payload from Admin User = ', data);
    let request = {
      user_id: data.userId,
      group_id: data.permissionGroupId,
      is_active: data.isActive,
    };
    return axios.put(`${userPermissionBase}/${data.id}`, request);
  };

  static getMyPermissions = () => {
    return axios.get(`${myPermissionBase}`);
  };
}

let userBase = 'auth/admin/user';
let userPermissionBase = 'dashboard/user-permission-group';
let myPermissionBase = 'auth/admin/mypermission';

export default UserApi;
